<ng-container *transloco="let t">
  <div class="admin-card">
    <!--    LG filter -->

      <div class="filter-wrapper hide-below-xxl">
        <app-admin-actions-header (onExportToPdf)="downloadListOfEvents('pdf')"
                                  (onExportToXls)="downloadListOfEvents('xlsx')">
          <div slot="leadingWidgets" class="d-flex flex-column flex-md-row">
            <div class="d-flex flex-column flex-xxl-row">
              <div class="me-2 mb-3 mb-md-0">
                <app-search-rounded [name]="name" [placeholder]="t('explore.search')"
                                    (searchEmitter)="handleSearchInput($event)"></app-search-rounded>
              </div>
              <div class="w-180 d-flex align-items-center">
                <app-select [hasDefault]="true" [items]="eventStatuses" [ngModel]="statusId" [defaultValue]="undefined"
                            [defaultLabel]="t('app.common.all')" [placeholder]="t('app.common.status')" [valueKey]="'id'" [labelKey]="'id'"
                            labelKeyPrefix="event.item.status." (ngModelChange)="onStatusChange($event)"
                            [fullWidthDropdown]="true"/>
              </div>
              @if (authService.isAdminstrator()) {
                <div class="w-180 d-flex align-items-center">
                  <app-select [hasDefault]="true" [items]="organisers" [ngModel]="organiserId"
                              class="ms-md-2 ms-0 mt-md-0 mt-3" [defaultValue]="undefined"
                              [defaultLabel]="t('app.common.all')" [placeholder]="t('app.common.organiser')" [valueKey]="'id'" [labelKey]="'name'"
                              (ngModelChange)="onOrganiserChange($event)" [fullWidthDropdown]="true"/>
                </div>
              }
              <div class="ms-2">
                <app-rounded-button [btnClass]="'rounded-button--muted rounded-button--sm fixed-height'" (onClick)="onRefreshFilters()">
                  <i class="bi bi-trash3-fill"></i>
                </app-rounded-button>
              </div>
              @if (from != ListOfEventsComponent.MEASUREMENTS) {
                <div class="ms-2">
                  <app-rounded-button [btnClass]="'rounded-button--solid'"
                                      [label]="t('events.details.organiser.add.new.event')" (onClick)="goToAddEvent()"><i
                    class="bi bi-plus-circle pe-2"></i></app-rounded-button>
                </div>
              }
            </div>
          </div>
        </app-admin-actions-header>
      </div>


    <!--    Mobile filter -->
    <div class="filter-wrapper hide-xxl-and-up">
      <app-admin-actions-header [isXlsVisible]="false" [isPdfVisible]="false">
        <div slot="leadingWidgets">
          <app-search-rounded [name]="name" [placeholder]="t('explore.search')"
                              (searchEmitter)="handleSearchInput($event)"></app-search-rounded>
        </div>
      </app-admin-actions-header>
    </div>

    <app-loader [isLoading]="isLoading"></app-loader>
    @if (events.length > 0) {
      <div>
        <ng-template [ngTemplateOutlet]="listOfEventsWeb"></ng-template>
        <ng-template [ngTemplateOutlet]="listOfEventsMobile"></ng-template>
      </div>
    } @else {
      <div class="px-3 px-lg-4">
        <app-empty-state/>
      </div>
    }
    @if (hasMoreEvents) {
      <app-admin-load-more (loadMore)="loadMore()"/>
    }
    @if (showFabButton && (events?.length ?? 0) > 0) {
      <div (click)="scrollToTop()" class="scroll-to-top">
        <i class="bi bi-arrow-up"></i>
      </div>
    }
  </div>

  <ng-template #listOfEventsWeb>
    <div class="table-wrapper">
    <div class="table-responsive d-xl-block d-none">
      <app-sortable-table cssClass="table dark-header table-last-row-no-border" [items]="events">
        <thead>
        <tr>
          <th [sortBy]="['id']" class="id-column">{{t("event.item.id")}}</th>
          <th [sortBy]="['name']">{{t("event.item.name")}}</th>
          @if (authService.isAdminstrator()) {
            <th [sortBy]="['organiser.name']">
              {{t("events.details.organiser")}}
            </th>
          }
          <th [sortBy]="['start']" data-type="date" class="start-column">{{t("event.item.start")}}</th>
          <th [sortBy]="['status']" class="status-column-width">{{t("event.item.status")}}
          </th>
          <th [sortBy]="['competitorCount.total']" class="competitor-count-column">
            {{t("event.item.participants")}}
          </th>
          @if (from != ListOfEventsComponent.MEASUREMENTS) {
            <th class="more-column-width">
              {{t("app.common.edit")}}
            </th>
          }
        </tr>
        </thead>
        <tr app-table-header-separator></tr>
        <tbody>
          @for (event of events;track trackByFn) {
            <tr>
              <td class="center-align">{{event.id}}</td>
              <td class="center-align">
                <a class="text-black fw-semibold" (click)="goToEventManagement(event)">
                  <app-language-output [hrLabel]="event.name" [enLabel]="event.nameEng" [itLabel]="event.nameIta"
                                       [siLabel]="event.nameSlo" [srLabel]="event.nameSr" [bsLabel]="event.nameBs"
                                       [defaultLanguage]="event.defaultLanguage" [languages]="languages"/>
                </a>
              </td>
              @if (authService.isAdminstrator()) {
                <td class="center-align">{{event.organiser?.name}}</td>
              }
              <td class="center-align">{{event.start | localizedDate:'short'}}
              </td>
              <td class="center-align">
                <div class="status-badge"
                     [ngClass]="{'publishing': event.status === 0 , 'accepted': event.status === 1, 'denied': event.status === 2 , 'on-hold': event.status === 7}">
                  <span class="fw-bold">
                    {{t("event.item.status." + event.status) | uppercase}}
                  </span>
                </div>
              </td>
              <td class="center-align">{{event.competitorCount?.total}}</td>

              @if (from != ListOfEventsComponent.MEASUREMENTS) {
                <td class="text-end center-align">
                  <div ngbDropdown class="dropdown dropdown--remove-arrow" container="body">
                  <span class="menu-icon" id="eventActionsDropdown" ngbDropdownToggle>
                    <i class="fas fa-ellipsis-v"></i>
                  </span>
                    <ul aria-labelledby="eventActionsDropdown" ngbDropdownMenu>
                      <li ngbDropdownItem (click)="goToOrganiserEventDetails(event)">{{
                          t("app.common.details")
                        }}
                      </li>
                      <li ngbDropdownItem (click)="goToCopyEvent(event)">{{t("app.common.copy")}}</li>
                      @if (shouldShowPublishButton(event)) {
                        <li ngbDropdownItem (click)="onPublish(event)">
                          {{t("event.item.publish")}}
                        </li>
                      }
                      <li ngbDropdownItem (click)="goToEventPreview(event)">
                        {{t("event.item.card.preview")}}
                      </li>
                      @if ((isAdministrator || event.status === EventStatus.INACTIVE)
                      && !(event?.startItems | filterByField:'started':null:true)?.length) {
                        <li ngbDropdownItem (click)="openEraseEventConfirmationDialog(event)">
                          {{t("app.common.delete")}}
                        </li>
                      }
                    </ul>
                  </div>
                </td>
              }
            </tr>
          }
        </tbody>
      </app-sortable-table>
    </div>
    </div>
  </ng-template>

  <ng-template #listOfEventsMobile>
    @for (event of events;let isLast = $last;track trackByFn) {
      <div class="d-block d-xl-none" (click)="goToTiming(event)">
        <div class="d-flex justify-content-center align-items-center mobile-table-row" [class.isLastRow]="isLast">
          <div class="flex-grow-1">
            <div class="d-flex flex-column" [class.isLastRow]="isLast">
              <div>
                <strong>{{t("event.item.id")}}:</strong> {{event.id}}
              </div>
              <div>
                <strong>{{t("event.item.name")}}:</strong> {{event.name}}
              </div>
              <div>
                <strong>{{t("event.item.start")}}:</strong> {{
                  event.start |
                    localizedDate:'short'
                }}
              </div>
              <div></div>
              <div>
                <strong>{{t("event.item.participants")}}:</strong> {{event.competitorCount?.total}}
              </div>

              <div>
                <strong>{{t("event.item.status")}}:</strong> {{t("event.item.status." + event.status)}}
              </div>
              @if (authService.isAdminstrator()) {
                <div>
                  <strong>{{t("events.details.organiser")}}</strong> : {{event.organiser?.name}}
                </div>
              }
            </div>
          </div>
<!--          @if (from != ListOfEventsComponent.MEASUREMENTS) {-->
<!--            <div>-->
<!--              <div ngbDropdown class="dropdown dropdown&#45;&#45;remove-arrow" container="body">-->
<!--                <span class="menu-icon" id="eventActionsDropdownMobile" ngbDropdownToggle>-->
<!--                  <i class="fas fa-ellipsis-v"></i>-->
<!--                </span>-->
<!--                <ul aria-labelledby="eventActionsDropdownMobile" ngbDropdownMenu>-->
<!--                  <li ngbDropdownItem (click)="goToOrganiserEventDetails(event)">{{t("app.common.details")}}</li>-->
<!--                  <li ngbDropdownItem (click)="goToCopyEvent(event)">{{t("app.common.copy")}}</li>-->
<!--                  @if (shouldShowPublishButton(event)) {-->
<!--                    <li ngbDropdownItem (click)="onPublish(event)">-->
<!--                      {{t("event.item.publish")}}-->
<!--                    </li>-->
<!--                  }-->
<!--                  <li ngbDropdownItem (click)="goToEventPreview(event)">-->
<!--                    {{t("event.item.card.preview")}}-->
<!--                  </li>-->
<!--                  <li ngbDropdownItem (click)="openEraseEventConfirmationDialog(event)">{{-->
<!--                      t("app.common.delete")-->
<!--                    }}-->
<!--                  </li>-->
<!--                </ul>-->
<!--              </div>-->
<!--            </div>-->
<!--          }-->
        </div>
      </div>
    }
  </ng-template>
</ng-container>
